// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoleSelectorModal_overlay__GXXjV {
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(1rem, env(safe-area-inset-top)) 1rem
    max(1rem, env(safe-area-inset-bottom));
  overflow-y: auto;
  overscroll-behavior: contain;
  box-sizing: border-box;
}

.RoleSelectorModal_backdrop__LNXz\\+ {
  position: fixed;
  inset: 0;
  border: none;
  background: rgba(10, 10, 10, 0.48);
  cursor: pointer;
}

.RoleSelectorModal_dialog__4zNTf {
  position: relative;
  z-index: 1;
  width: min(100%, 480px);
  max-height: min(90vh, 640px);
  margin: auto;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 16px;
  padding: 1.75rem 1.5rem 1.5rem;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.16);
}

.RoleSelectorModal_closeBtn__Y9iqi {
  position: absolute;
  top: 0.85rem;
  right: 0.85rem;
  width: 2rem;
  height: 2rem;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background: #ffffff;
  color: #4a4a4a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;
}

.RoleSelectorModal_closeBtn__Y9iqi:hover {
  border-color: #ff5c09;
  color: #ff5c09;
}

.RoleSelectorModal_title__pAVQv {
  margin: 0 0 0.45rem;
  padding-right: 2rem;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.25;
  color: #0a0a0a;
}

.RoleSelectorModal_subtitle__b8Jrs {
  margin: 0 0 1.35rem;
  font-size: 0.92rem;
  line-height: 1.5;
  color: #4a4a4a;
}

.RoleSelectorModal_options__LJy5z {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.RoleSelectorModal_option__fAkTF {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  padding: 1rem 1.05rem;
  border: 1px solid #e5e5e5;
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  background: #ffffff;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.15s ease;
}

.RoleSelectorModal_option__fAkTF:hover {
  border-color: #ff5c09;
  box-shadow: 0 8px 24px rgba(255, 92, 9, 0.08);
  transform: translateY(-1px);
  color: inherit;
}

.RoleSelectorModal_optionIcon__mgzEl {
  flex-shrink: 0;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff4ed;
  color: #ff5c09;
}

.RoleSelectorModal_optionCopy__cWXQX {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
}

.RoleSelectorModal_optionTitle__HqCw4 {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0a0a0a;
}

.RoleSelectorModal_optionSubtext__5t8yA {
  font-size: 0.88rem;
  line-height: 1.45;
  color: #555555;
}

@media (max-width: 480px) {
  .RoleSelectorModal_dialog__4zNTf {
    padding: 1.5rem 1.15rem 1.25rem;
  }

  .RoleSelectorModal_title__pAVQv {
    font-size: 1.2rem;
  }

  .RoleSelectorModal_option__fAkTF {
    padding: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/RoleSelectorModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;0CACwC;EACxC,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB;;;wBAGsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: max(1rem, env(safe-area-inset-top)) 1rem\n    max(1rem, env(safe-area-inset-bottom));\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  box-sizing: border-box;\n}\n\n.backdrop {\n  position: fixed;\n  inset: 0;\n  border: none;\n  background: rgba(10, 10, 10, 0.48);\n  cursor: pointer;\n}\n\n.dialog {\n  position: relative;\n  z-index: 1;\n  width: min(100%, 480px);\n  max-height: min(90vh, 640px);\n  margin: auto;\n  overflow-y: auto;\n  background: #ffffff;\n  border: 1px solid #e5e5e5;\n  border-radius: 16px;\n  padding: 1.75rem 1.5rem 1.5rem;\n  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.16);\n}\n\n.closeBtn {\n  position: absolute;\n  top: 0.85rem;\n  right: 0.85rem;\n  width: 2rem;\n  height: 2rem;\n  border: 1px solid #e5e5e5;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #4a4a4a;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: border-color 0.2s ease, color 0.2s ease;\n}\n\n.closeBtn:hover {\n  border-color: #ff5c09;\n  color: #ff5c09;\n}\n\n.title {\n  margin: 0 0 0.45rem;\n  padding-right: 2rem;\n  font-size: 1.35rem;\n  font-weight: 800;\n  line-height: 1.25;\n  color: #0a0a0a;\n}\n\n.subtitle {\n  margin: 0 0 1.35rem;\n  font-size: 0.92rem;\n  line-height: 1.5;\n  color: #4a4a4a;\n}\n\n.options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  padding: 1rem 1.05rem;\n  border: 1px solid #e5e5e5;\n  border-radius: 12px;\n  text-decoration: none;\n  color: inherit;\n  background: #ffffff;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease,\n    transform 0.15s ease;\n}\n\n.option:hover {\n  border-color: #ff5c09;\n  box-shadow: 0 8px 24px rgba(255, 92, 9, 0.08);\n  transform: translateY(-1px);\n  color: inherit;\n}\n\n.optionIcon {\n  flex-shrink: 0;\n  width: 2.6rem;\n  height: 2.6rem;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff4ed;\n  color: #ff5c09;\n}\n\n.optionCopy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  min-width: 0;\n}\n\n.optionTitle {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #0a0a0a;\n}\n\n.optionSubtext {\n  font-size: 0.88rem;\n  line-height: 1.45;\n  color: #555555;\n}\n\n@media (max-width: 480px) {\n  .dialog {\n    padding: 1.5rem 1.15rem 1.25rem;\n  }\n\n  .title {\n    font-size: 1.2rem;\n  }\n\n  .option {\n    padding: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `RoleSelectorModal_overlay__GXXjV`,
	"backdrop": `RoleSelectorModal_backdrop__LNXz+`,
	"dialog": `RoleSelectorModal_dialog__4zNTf`,
	"closeBtn": `RoleSelectorModal_closeBtn__Y9iqi`,
	"title": `RoleSelectorModal_title__pAVQv`,
	"subtitle": `RoleSelectorModal_subtitle__b8Jrs`,
	"options": `RoleSelectorModal_options__LJy5z`,
	"option": `RoleSelectorModal_option__fAkTF`,
	"optionIcon": `RoleSelectorModal_optionIcon__mgzEl`,
	"optionCopy": `RoleSelectorModal_optionCopy__cWXQX`,
	"optionTitle": `RoleSelectorModal_optionTitle__HqCw4`,
	"optionSubtext": `RoleSelectorModal_optionSubtext__5t8yA`
};
export default ___CSS_LOADER_EXPORT___;
